"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../core/button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *******************************************************************************
// Define the button that allows users to enter/cancel etc
// *******************************************************************************

class JoinRaceButton extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      loading: false
    });
    _defineProperty(this, "_setLoading", result => {
      this.setState({
        loading: true
      });
      result.then(() => this.setState({
        loading: false
      }), () => this.setState({
        loading: false
      }));
    });
    _defineProperty(this, "_onEnterRace", () => {
      if (this.state.loading) return;
      return this._setLoading(this.props.onEnterRace(this.props.raceEligibility).then(result => {
        if (result && result.error) {
          return this.props.setEntryError(result.error);
        }
      }));
    });
    _defineProperty(this, "_onJoinWaitingList", () => {
      return this._setLoading(this.props.onJoinWaitingList(this.props.raceEligibility));
    });
    _defineProperty(this, "_onRemoveEntry", () => {
      this._setLoading(this.props.onRemoveEntry(this.props.raceEligibility));
    });
  }
  render() {
    const raceEligibility = this.props.raceEligibility;
    const raceID = raceEligibility.race.id;
    return /*#__PURE__*/_react.default.createElement("div", null, raceEligibility.eligibilityStatus.canEnterNow ? /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-test-id": 'enter-race-btn-' + raceID,
      type: "primary",
      loading: this.state.loading,
      onClick: this._onEnterRace
    }, "Enter Race") : raceEligibility.eligibilityStatus.canAddToWaitingList ? /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-test-id": 'join-waiting-btn-' + raceID,
      type: "primary",
      loading: this.state.loading,
      onClick: this._onJoinWaitingList
    }, "Join Waiting List") : raceEligibility.eligibilityStatus.canRemoveEntry ? /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-test-id": 'remove-entry-btn-' + raceID,
      loading: this.state.loading,
      onClick: this._onRemoveEntry
    }, raceEligibility.eligibilityStatus.status === 'DRAFT' ? 'Remove From Basket' : 'Remove Entry') : null);
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(JoinRaceButton, "propTypes", {
  raceEligibility: _propTypes.default.object.isRequired,
  cseBibID: _propTypes.default.number.isRequired,
  classDivisionID: _propTypes.default.number.isRequired
});
_defineProperty(JoinRaceButton, "partialQueries", {
  Race: {
    id: true
  },
  EligibilityStatus: {
    status: true,
    canAddToWaitingList: true,
    canEnterNow: true,
    canRemoveEntry: true,
    entryID: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(JoinRaceButton, undefined, (client, props) => ({
  onEnterRace(raceEligibility) {
    return client.update('Entry.create', {
      classDivisionID: props.classDivisionID,
      cseBibID: props.cseBibID,
      raceID: raceEligibility.race.id,
      waitList: false,
      isOnlineEntry: true
    });
  },
  onJoinWaitingList(raceEligibility) {
    if (raceEligibility.eligibilityStatus.entryID) {
      return client.update('Entry.moveDraftEntryToWaitingList', {
        entryID: raceEligibility.eligibilityStatus.entryID
      });
    } else {
      return client.update('Entry.create', {
        classDivisionID: props.classDivisionID,
        cseBibID: props.cseBibID,
        raceID: raceEligibility.race.id,
        waitList: true,
        isOnlineEntry: true
      });
    }
  },
  onRemoveEntry(raceEligibility) {
    return client.update('Entry.remove', {
      entryID: raceEligibility.eligibilityStatus.entryID
    });
  }
}));